module.exports = __webpack_public_path__ + "static/media/close.a53d57a8.svg";